import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextNormProps {
    children: ReactNode
    className?: string
}

const TextNorm = ({ children, className }: TextNormProps) => {
    return <span className={[css.norm, className].filter(Boolean).join(' ')}>{children}</span>
}

export default TextNorm
